export type ImpactGroup = {
  id?: number;
  userId?: string;
  name?: string;
  logoImageKey?: string | null;
  createdAt?: string;
  updatedAt?: string;
};
